import API from "../../../../../services/api";


export const PLANTILLAS_EMAIL_API = {
  get:async () => {
    return await API.get("/plantillas-email").then((res) => res.data);
  },
  new: async (data) => {
    return await API.post("/plantillas-email", data).then((res) => res.data);
  },
  update: async (id, data) => {
    return await API.put(`/plantillas-email/${id}`, data).then((res) => res.data)
  }
}
